/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { ComparePage } from 'landing-pages/compare/ComparePage';
import { getSayariCompareData } from 'landing-pages/compare/data/sayari';

export const GlobalDatabaseVsSayariPage = () => {
  const { t } = useInt();

  return <ComparePage data={getSayariCompareData(t)} />;
};
